<template>
    <div class="search-container">
        <div class="search-box df pt-24">
            <form class="form-box df">
                <el-input v-model="search_key" class="areacode-ipt" :placeholder="$t('请输入关键字')"></el-input>
                <el-button type="primary" class="search-btn ml-24" @click="handleSubmit">{{ $t('搜索') }}</el-button>
            </form>
        </div>
        <div class="container-box" v-loading="loading" element-loading-text="加载中">
            <el-tabs v-model="activeName" @tab-click="handleClick">

                <el-tab-pane :label="$t('文章')" name="0">
                    <template v-if="dataList && dataList.length > 0 && activeName == 0">
                        <div class="discuss-box">
                            <div class="list-box" v-loading="listLoading">
                                <div class="list" v-for="(items, indexs) in dataList" :key="indexs"
                                    @click="$navigate('/subject/info', items.ttar_id)">
                                    <div class="t1s df jcsb aic over-h">
                                        <div class="mic-semblod df aic one-text">
                                            <span class="essence mt-4" v-if="items.ttar_rec == 900">{{ $t("精1") }}</span>
                                            <!-- 暂时不显示热 -->
                                            <span class="hot mt-4" style="background-color: #fdb906ff"
                                                v-if="items.ttar_rec == 1000">{{
                                                    $t("顶1")
                                                }}</span>
                                            <div class="f1 one-text ml-2"
                                                v-html="highlightText(items.ttar_title, search_key)"></div>
                                        </div>
                                    </div>
                                    <div class="desc tow-text" :title="items.ttar_desc">
                                        <div v-html="highlightText(items.ttar_desc, search_key)"></div>
                                    </div>
                                    <div class="userinfo-box df jcsb aic over-h">
                                        <div class="users df aic f1 over-h">
                                            <div @click="(event) => handleaAvatar(event, items)" class="df">
                                                <template v-if="items.ttar_type == 10">
                                                    <el-avatar :size="18" :src="items.user_avatar_att_url" class="fn"
                                                        @error="handleImageError">
                                                        <img src="@/assets/images/avatar.png" alt="" />
                                                    </el-avatar>
                                                </template>
                                                <template v-else>
                                                    <el-avatar :size="18" :src="require('@/assets/images/avatar.png')"
                                                        class="fn"></el-avatar>
                                                </template>
                                            </div>
                                            <span class="name fn">
                                                {{
                                                    items.is_expert == 10
                                                        ? items.user_name
                                                        : items.ttar_type == 20 ||
                                                            items.user_id == 0 ||
                                                            items.user_nick_name === "" ||
                                                            items.user_nick_name === null
                                                            ? $t("匿名用户")
                                                            : items.user_nick_name
                                                }}
                                            </span>
                                            <div class="f1 type one-text" v-if="items.user_excel_arr.length">
                                                <span v-for="items1 in items.user_excel_arr" :key="items1.label">{{
                                                    items1.label }}</span>
                                            </div>
                                        </div>
                                        <div class="dates df fn">
                                            <div class="comment-list df">
                                                <div class="li">
                                                    <span class="iconfont">&#xe611;</span>
                                                    <span class="text">{{ items.ttar_hits }}</span>
                                                </div>
                                                <div class="li">
                                                    <span class="iconfont">&#xe61b;</span>
                                                    <span class="text">{{ items.ttar_likes }}</span>
                                                </div>
                                                <div class="li">
                                                    <span class="iconfont">&#xe63e;</span>
                                                    <span class="text">{{ items.reply_count }}</span>
                                                </div>
                                            </div>
                                            <span class="date">{{ items.create_time }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </template>
                </el-tab-pane>
                <el-tab-pane :label="$t('活动')" name="1">
                    <template v-if="dataList && dataList.length > 0 && activeName == 1">
                        <div class="active-listcontent df fww">
                            <div class="list" v-for="(item, index) in dataList" @click="handleLink(item)">
                                <div class="img-box">
                                    <el-image :src="item.ta_thumb" fit="cover">
                                        <div slot="error" class="image-slot">
                                            <img src="@/assets/images/news-default.png" alt="">
                                        </div>
                                    </el-image>
                                </div>
                                <div class="list-box">
                                    <div class="title mic-semblod one-text">
                                        <div class="one-text" v-html="highlightText(item.ta_title, search_key)"></div>
                                    </div>
                                    <div class="desc one-text" style="white-space: nowrap;">
                                        <div class="one-text" v-html="highlightText(item.ta_desc, search_key)"></div>
                                    </div>
                                    <div class="date-box df aic jcsb">
                                        <div class="le over-h">
                                            <div class="address one-text">
                                                <span class="iconfont">&#xe61f;</span>{{ item.ta_city_text }}
                                            </div>
                                            <div class="date"><span class="iconfont">&#xe602;</span>{{
                                                item.ta_start_time }}</div>
                                        </div>
                                        <div class="ri fn">
                                            <el-button type="success" class="end" v-if="item.is_sign_up == 10">
                                                {{ $t('活动已结束') }}
                                            </el-button>
                                            <el-button type="success" v-else-if="item.is_sign_up == 20">
                                                {{ $t('即将举行') }}
                                            </el-button>
                                            <el-button type="success" v-else-if="item.is_sign_up == 30">
                                                {{ $t('活动报名中') }}
                                            </el-button>
                                            <el-button type="success" v-else-if="item.is_sign_up == 40">
                                                {{ $t('活动进行中') }}
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </el-tab-pane>
                <el-tab-pane :label="$t('社区')" name="2">
                    <template v-if="dataList && dataList.length > 0 && activeName == 2">
                        <div class="discuss-box">
                            <div class="list-box">
                                <div class="list" v-for="(items, indexs) in dataList" :class="{
                                    'hot-box': items.tp_rec == 1000,
                                    'essence-box': [0, 1, 2].indexOf(indexs) != -1 && pagination.page == 1
                                }" :key="indexs" @click="$navigate('/discuss/info', items.tp_id)">
                                    <div class="t1s df jcsb over-h">
                                        <div class="mic-semblod df aic">
                                            <span class="essence" v-if="items.tp_rec == 900">{{
                                                $t("精1")
                                                }}</span>
                                            <span class="hot" v-if="hits_top_post_id.indexOf(items.tp_id) != -1">{{ $t('热1') }}</span>
                                            <span class="hot" style="background-color: #FDB906FF;" v-if="items.tp_is_top == 10">{{ $t('顶1') }}</span>
                                            <!-- 
                                      -->
                                            <div class="tow-text" v-html="highlightText(items.tp_title, search_key)">
                                            </div>
                                        </div>
                                        <div class="show-box fn">
                                            <img v-if="items.tp_is_top == 10" src="@/assets/images/hot.png" alt="" />
                                            <img v-if="[0, 1, 2].indexOf(indexs) != -1 && pagination.page == 1"
                                                src="@/assets/images/essence.png" alt="" />
                                        </div>
                                    </div>
                                    <!-- <div class="desc tow-text" :title="items.ttar_desc">
                                <div v-html="highlightText(items.tp_desc, search_key)"></div>
                            </div> -->

                                    <div class="userinfo-box df jcsb aic over-h">
                                        <div class="users df aic f1 over-h">
                                            <div class="df fn" @click.stop="handleUserinfo(items)">
                                                <template v-if="items.tp_type == 10">
                                                    <el-avatar :size="18" :src="items.user_avatar_att_url" class="fn"
                                                        @error="handleImageError">
                                                        <img src="@/assets/images/avatar.png" alt="" />
                                                    </el-avatar>
                                                </template>
                                                <template v-else>
                                                    <el-avatar :size="18" :src="''" class="fn"
                                                        @error="$erroravatarHandler">
                                                        <img src="@/assets/images/avatar.png" alt="" />
                                                    </el-avatar>
                                                </template>
                                            </div>

                                            <span class="name fn">
                                                {{ getUserName(items) }}
                                            </span>

                                            <div class="f1 type one-text" v-if="items.user_excel_arr.length">
                                                <span v-for="(items1, indexs1) in items.user_excel_arr"
                                                    :key="indexs1">{{
                                                        items1.label }}</span>
                                            </div>
                                        </div>

                                        <div class="dates df fn">
                                            <div class="comment-list df">
                                                <div class="li">
                                                    <span class="iconfont">&#xe611;</span>
                                                    <span class="text">{{ items.tp_hits }}</span>
                                                </div>
                                                <div class="li">
                                                    <span class="iconfont">&#xe61b;</span>
                                                    <span class="text">{{ items.tp_likes }}</span>
                                                </div>
                                                <div class="li">
                                                    <span class="iconfont">&#xe63e;</span>
                                                    <span class="text">{{ items.reply_count }}</span>
                                                </div>
                                            </div>
                                            <span class="date">{{
                                                items.tp_published_time * 1000, "YYYY.MM.DD HH:mm" | formatTime
                                                }}</span>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </template>
                </el-tab-pane>
                <div class="pageing-box df aic jcc" v-if="dataList.length > 0">
                    <el-button type="text" class="add-btn" @click="handlePages(1)">{{ $t('回首页') }}</el-button>
                    <el-pagination :current-page="pagination.page" :page-size="pagination.per_page"
                        :total="pagination.total" layout=" prev, pager, next,slot" @current-change="handleCurrent">
                        <span class="jump-text">{{ $t('跳转') }}</span>
                        <el-input-number :controls="false" v-model="jumpIndex" :min="1" :max="totalPages"
                            @change="handleJump" size="small" class="jump-ipt" style="width: 48px; margin-left: 8px;" />
                    </el-pagination>
                    <el-button type="text" class="add-btn ml-11"
                        @click="handlePages(totalPages)">{{ $t('去尾页') }}</el-button>
                </div>
            </el-tabs>
            <div class="no-data pt-86" v-if="dataList.length == 0">
                <img src="@/assets/images/empty_data.png" alt="" />
                <p>{{ $t("暂无数据") }}</p>
            </div>

        </div>

    </div>
</template>
<script>
import { globalSearch } from "@api/home";
export default {
    data() {
        return {
            search_key: '',
            activeName: '0',
            dataList: [],
            pagination: {
                page: 1,
                total: 0,
                per_page: 0,

            },
            totalPages: 0, //总页数
            jumpIndex: '',
            listLoading: false,

            loading: false,
            hits_top_post_id:[],

        }
    },
    mounted() {
        // 设置默认的顶部菜单背景色
        this.$bus.$emit('changeNavbg', 'rgba(255, 255, 255, 1);');
        // this.getData();
    },
    created() {
        // 从路径参数中获取 `keyword`
        this.search_key = this.$route.params.search_key;
        console.log(this.search_key)
        if (this.search_key != '') {
            this.getData();
        }
    },
    methods: {
        // 跳转
        handleJump() {
            this.pagination.page = this.jumpIndex;
            this.getData();
        },
        // 搜索
        handleSubmit() {
            this.getData();
        },
        async getData() {
            // 添加loading


            this.loading = true;
            const res = await globalSearch({
                search_key: this.search_key,
                search_type: this.activeName,
                page: this.pagination.page
            });

            this.loading = false;
            if (res.status == 200) {
                this.pagination.total = res.data.data_list.total;
                this.pagination.per_page = res.data.data_list.per_page;
                this.totalPages = Math.ceil(this.pagination.total / this.pagination.per_page);
                this.dataList = res.data.data_list.data
                if(this.activeName == 2){
                    this.hits_top_post_id = res.data.hits_top_post_id
                }
                //console.log(this.dataList)
            }
        },
        handleClick(tab, event) {
            this.activeName = tab.index
            this.dataList = []
            this.pagination.page = 1
            //console.log(tab.index);
            this.getData();
        },
        // 跳转详情
        handleLink(item) {
            let str = '/cn';
            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = '/' + Language;
            }
            let target = {}
            // 判断是否是精英赛
            if (item.ta_kind == 30) {
                target = this.$router.resolve(str + '/challenge/info/' + item.ta_id)
            } else {
                target = this.$router.resolve(str + '/activity/info/' + item.ta_id)
            }
            window.open(target.href, '_blank');
        },
        handlePages(index) {
            this.pagination.page = index;
            this.getData();
        },
        // 分页改变
        handleCurrent(val) {
            this.pagination.page = val;
            this.getData();
        },
        // 头像加载失败
        handleImageError() {
            return true;
        },
        handleCurrentChange(val) {
            this.pagination.page = val;
            this.getData();
        },
        getUserName(item) {
            if ((item.tp_type == 10) && item.user_nick_name) {
                return item.user_nick_name
            }
            return this.$t("匿名用户")
        },
        // 头像显示个人信息

        handleaAvatar(event, item) {
            // 判断是否是实名用户
            if (
                item.ttar_type == 20 ||
                item.user_id == 0 ||
                item.user_nick_name == "" ||
                item.user_nick_name == null
            ) {
                return false;
            }
            event.stopPropagation(); // 阻止事件冒泡
            this.$refs.avatarDialog.openModal();
            console.log(212121212121);
            console.log(item);

            this.id = item.user_id;
            console.log(this.id);
        },
        highlightText(text, keyword) {
            if (!text || !keyword) return text;
            // 转义特殊字符（防止XSS和正则错误）
            const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regex = new RegExp(`(${escapedKeyword})`, 'gi');
            return text.replace(regex, '<span class="highlight-keyword">\$1</span>');
        }
    }
}
</script>
<style>
.highlight-keyword {
    color: #b7251e;
}
</style>


<style lang="scss" scoped>
::v-deep() {
    .el-pagination {
        display: flex;
        align-items: center;
    }

    .el-pager li {
        background: transparent;
    }

    .el-pagination .btn-prev,
    .el-pagination .btn-next {
        background-color: transparent;
    }
}

.pageing-box {
    margin-top: 60px;
    padding-bottom: 120px;


}


.active-listcontent {
    padding-bottom: 40px;

    .list {
        width: calc(33.33% - 13.33px);
        height: 430px;
        border-radius: 6px;
        box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
        background: rgb(255, 255, 255);
        margin-top: 20px;
        overflow: hidden;
        cursor: pointer;

        &:hover {
            ::v-deep() {
                .el-image {
                    transform: scale(1.1);
                }
            }

            .list-box .title {
                color: #B7251E;
            }
        }

        .img-box {
            width: 100%;
            height: 300px;
            overflow: hidden;

            ::v-deep() {
                .image-slot {
                    height: 100%;
                }
            }



            ::v-deep .el-image {
                width: 100%;
                height: 100%;
                transition: all 1s;
            }

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }

        .list-box {
            padding: 16px;

            .title {
                color: rgb(25, 25, 25);
                font-size: 18px;
                font-weight: 400;
                line-height: 28px;
            }

            .desc {
                color: rgb(89, 89, 89);
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                height: 22px;
                margin-top: 8px;
            }

            .date-box {
                padding-top: 4px;

                .le {
                    color: rgb(89, 89, 89);
                    font-size: 12px;
                    font-weight: 400;
                    line-height: 18px;

                    span {
                        font-size: 14px;
                        margin-right: 5px;
                    }
                }

                .ri {
                    ::v-deep() {
                        .el-button {
                            border: none;
                            color: #1872FD;
                            min-width: 96px;
                            height: 36px;
                            border-radius: 20px;
                            background: rgb(231, 239, 255);
                            padding: 0 16px;
                        }
                    }

                    .end {
                        color: #6d7177;
                        background: #ffffff;
                        border: 1px solid #6d7177;
                    }
                }
            }
        }

        &:nth-child(3n) {
            margin-left: 20px;
        }

        &:nth-child(3n-1) {
            margin-left: 20px;
        }
    }
}

.container-box {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 24px;
}

.search-container {
    width: 100%;
    min-height: calc(100vh - 280px);
    background-size: cover;
    background-color: #fafbfd;
    padding: 60px 80px 0;


    .search-box {
        max-width: 1400px;
        margin: 0 auto;

        .areacode-ipt {
            width: 290px;
        }
    }
}

//活动

//社区

.discuss-box {
    .list-box {
        margin-top: 18px;

        .list {
            padding: 16px 0px;
            border-bottom: 1px solid rgb(226, 226, 226);
            cursor: pointer;
            transition: border-bottom 0.36s;
            z-index: 10;

            &:hover {
                border-bottom: 1px solid #b7251e;

                .t1s {
                    color: #b7251e;
                }
            }

            .t1s {
                color: rgb(25, 25, 25);
                font-size: 18px;
                font-weight: 400;
                line-height: 24px;
                padding: 2px 0;

                .essence,
                .hot {
                    display: inline-block;
                    min-width: 18px;
                    height: 18px;
                    border-radius: 2px;
                    font-size: 14px;
                    color: #ffffff;
                    line-height: 18px;
                    text-align: center;
                    margin-right: 4px;
                    position: relative;
                    padding: 0 2px;
                    top: -1px;
                }

                .essence {
                    background: rgb(215, 17, 17);
                    margin-top: 3px;
                }

                .hot {
                    background: rgb(255, 110, 0);
                }

                .show-box {
                    img {
                        margin-left: 6px;
                    }
                }
            }

            .desc {
                color: rgb(51, 51, 51);
                font-size: 14px;
                font-weight: 400;
                line-height: 22px;
                height: 44px;
                margin-top: 10px;
            }
        }

        .hot-box,
        .essence-box {
            position: relative;
            padding-right: 16px;

            &::after {
                content: "";
                display: block;
                width: 400px;
                height: calc(100% + 1px);
                opacity: 0.6;
                position: absolute;
                right: -40px;
                top: 0;
            }
        }

        .essence-box {
            &::after {
                background: linear-gradient(-64.32deg,
                        rgba(254, 190, 8, 0.21) -2.449%,
                        rgba(196, 196, 196, 0) 96.756%);
            }
        }

        .hot-box {
            &::after {
                background: linear-gradient(-64.32deg,
                        rgba(255, 0, 0, 0.11) -2.446%,
                        rgba(196, 196, 196, 0) 96.716%);
            }
        }

        .userinfo-box {
            height: 32px;
            margin-top: 8px;

            .name {
                font-size: 14px;
                margin-left: 6px;
            }
        }

        .type {
            height: 32px;
            position: relative;
            margin-left: 18px;
            padding: 5px 18px;

            &::after {
                content: "";
                display: block;
                height: 14px;
                width: 1px;
                background-color: #d8d8d8;
                position: absolute;
                top: 50%;
                margin-top: -7px;
                left: 0;
            }

            span {
                display: inline-block;
                height: 22px;
                background-color: #f0f1f1;
                border-radius: 4px;
                padding: 0 4px;
                color: #868d9f;
                line-height: 22px;
                font-size: 12px;
                margin-right: 6px;
            }
        }

        .dates {
            height: 32px;
            line-height: 32px;

            .date {
                font-size: 14px;
                color: #868d9f;
                position: relative;
                padding-left: 16px;

                &::after {
                    content: "";
                    display: inline-block;
                    height: 12px;
                    width: 1px;
                    background-color: #d8d8d8;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    margin-top: -6px;
                }
            }

            .comment-list {
                .li {
                    color: #868d9f;
                    font-size: 14px;
                    margin-right: 15px;

                    .iconfont {
                        margin-right: 5px;
                    }

                    .text {}
                }
            }
        }
    }
}
</style>